module.exports = __webpack_public_path__ + "img/story3.480435a2.png";